/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks, so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//** MEGA MENU */

const navBarMenu = document.querySelector("#nav-bar-menu")
const customMegaMenu = document.querySelector(".custom-mega-menu")

const navBarFirstItem = document.querySelector(".nav-bar__firstItem")

// console.log(navBarMenu.offsetHeight)

customMegaMenu.style = `top:${navBarMenu.offsetHeight}px;`
navBarFirstItem.style = `height:${navBarMenu.offsetHeight}px;`


// const sideBarLinklist = document.querySelectorAll(".nav-bar__parent-link")
const sideBarLinklist = document.querySelectorAll(".have-sub")
const closingSpan = document.querySelectorAll(".mega-menu-closing-span")
const megaMenuRightSide = document.querySelectorAll(".mega-menu__rightside")
const megaMenuLauncher = document.querySelector(".mega-menu-launcher")
const megaMenuInner = document.querySelector(".mega-menu__inner")
const innerClosingSpan = document.querySelector(".closing-span-inner")

function hideEL() {
    megaMenuRightSide.forEach(item => {
        item.classList.add("is-hide")
    })
    innerClosingSpan.style.display = "none"
}


sideBarLinklist.forEach(sideBarLink => {
    sideBarLink.addEventListener("mouseenter", () => {
        hideEL()
        const megaMenuRightSide = sideBarLink.querySelector(".mega-menu__rightside")
        if (megaMenuRightSide.classList.contains("is-hide")) {
            megaMenuRightSide.classList.remove("is-hide")
        }
        // sideBarLink.nextElementSibling.classList.remove("is-hide")
    })
})

closingSpan.forEach(span => {
    span.addEventListener("click", () => {
        hideEL()
        customMegaMenu.style.display = "none"
    })
})

megaMenuLauncher.addEventListener("mouseenter", () => {
    customMegaMenu.style.display = "block"
    innerClosingSpan.style.display = "block"
})

megaMenuInner.addEventListener("mouseleave", () => {
    customMegaMenu.style.display = "none"
    hideEL()
})

/**  age-verification  */


const menuAgeProtection = document.querySelector(".age-verification")

if (menuAgeProtection) {
    menuAgeProtection.addEventListener("click", function (evt) {
        document.cookie = 'ageProtection=true;';
    })
}

window.onbeforeunload = function () {
    document.cookie = 'ageProtection=true; max-age=0';
};


/**  newsletter checkbox  */
let newsletterCheckbox = document.querySelector('#newsletterAcceptTerms');
let newsletterSubmitButton = document.querySelector('#newsletterSubmit');

if (newsletterCheckbox) {
    newsletterCheckbox.addEventListener('change', function () {
        if (this.checked) {
            newsletterSubmitButton.classList.remove('disabled');
        } else {
            newsletterSubmitButton.classList.add('disabled');
        }
    });
}